// extracted by mini-css-extract-plugin
export var bubble = "_27-0";
export var container = "_27-f";
export var contrastBorder = "_27-g";
export var greyOut = "_27-2";
export var initialsColor0 = "_27-3";
export var initialsColor1 = "_27-4";
export var initialsColor10 = "_27-d";
export var initialsColor11 = "_27-e";
export var initialsColor2 = "_27-5";
export var initialsColor3 = "_27-6";
export var initialsColor4 = "_27-7";
export var initialsColor5 = "_27-8";
export var initialsColor6 = "_27-9";
export var initialsColor7 = "_27-a";
export var initialsColor8 = "_27-b";
export var initialsColor9 = "_27-c";
export var initialsWrapper = "_27-1";
export var large = "_27-l";
export var medium = "_27-k";
export var mediumSmall = "_27-j";
export var mediumSmallMedium = "_27-o";
export var micro = "_27-h";
export var small = "_27-i";
export var tiny = "_27-n";
export var xTiny = "_27-m";